import { translations as activatePage } from './activate-page';
import { translations as alertsPage } from './alerts-page';
import { translations as contactUsPage } from './contact-us-page';
import { translations as faqPage } from './faq-page';
// import { translations as homePage } from './home-page';
// import { translations as homePageV2 } from './home-page-v2';
import { translations as homePageV3 } from './home-page-v3';
import { translations as identityPage } from './identity-page';
import { translations as privacyPolicyPage } from './policy-page';
import { translations as productVideoNonMembers } from './product-video-non-members';
import { translations as productVideoMembers } from './product-video-members';
import { translations as protectionPage } from './protection-page';
import { translations as resourceCentrePage } from './resource-centre';
import { translations as siteFooter } from './site-footer';
import { translations as siteHeader } from './site-header';
import { translations as siteNavbar } from './site-navbar';
import { translations as termsAndConditionsPage } from './terms-conditions-page';
import { translations as termsOfUsePage } from './terms-page';
import { translations as ScamDetectionPage } from './scamdetection-page';

export const translations = {
  global: {
    siteTitle: 'EnGarde',
    pleaseWaitText: 'Veuillez patienter',
    requestProcessingWaitText: 'Veuillez patienter pendant que nous traitons votre <span class="text-nowrap">demande ...</span>',
    modalDismissActionText: 'Fermer',

    // tslint:disable:quotemark
    genericErrorMessage: "Une erreur s'est produite.",
    genericFormSubmitErrorMessage:
      'Un problème est survenu lors de la soumission de votre formulaire.\n' +
      "Veuillez nous appeler au 1 866 327-3078 pour obtenir de l'aide.",
    // tslint:enable:quotemark

    idGuardLinkPopupTitle: 'Vous allez maintenant être redirigé vers le site Web d’Identity Guard',
    idGuardLinkPopupBody: [
      'Vous serez maintenant dirigé vers le portail en ligne EnGarde alimenté par Assist Identité, où vous pourrez',
      'accéder à ces services. Les mêmes conditions d’utilisation que celles que vous avez acceptées lors de l’activation',
      'de votre abonnement s’appliquent.'
    ].join('\n'),
    bmoIdGuardLinkPopupBody: [
      'Les avantages liés à la surveillance et aux alertes sont fournis par Identity Guard<sup>®</sup>.',
      'Vous allez maintenant être redirigé vers le site Web de protection de l’identité pour',
      'accéder à ces services. Les mêmes conditions d’utilisation que celles que vous avez',
      'acceptées lors de l’activation de votre abonnement s’appliquent.'
    ].join('\n'),
    okay: 'OK',

    siteHeader,
    siteNavbar,
    siteFooter,

    provinces: [
      { key: 'AB', value: 'Alberta' },
      { key: 'BC', value: 'Colombie-Britannique' },
      { key: 'PE', value: 'Île-du-Prince-Édouard' },
      { key: 'MB', value: 'Manitoba' },
      { key: 'NB', value: 'Nouveau-Brunswick' },
      { key: 'NS', value: 'Nouvelle-Écosse' },
      { key: 'NU', value: 'Nunavut' },
      { key: 'ON', value: 'Ontario' },
      { key: 'QC', value: 'Québec' },
      { key: 'SK', value: 'Saskatchewan' },
      { key: 'NL', value: 'Terre-Neuve-et-Labrador' },
      { key: 'NT', value: 'Territoires du Nord-Ouest' },
      { key: 'YT', value: 'Yukon' }
    ],

    monthNames: [
      // IMPORTANT key must be zero-prefixed
      { key: '01', value: 'Janvier' },
      { key: '02', value: 'Février' },
      { key: '03', value: 'Mars' },
      { key: '04', value: 'Avril' },
      { key: '05', value: 'Mai' },
      { key: '06', value: 'Juin' },
      { key: '07', value: 'Juillet' },
      { key: '08', value: 'Août' },
      { key: '09', value: 'Septembre' },
      { key: '10', value: 'Octobre' },
      { key: '11', value: 'Novembre' },
      { key: '12', value: 'Décembre' }
    ]
  },
  pageAccessDenied: {
    pageTitle: 'Oh oups!',
    pageContent: [
      '<p>Ce contenu n&#39;est pas disponible dans votre région.<br/>',
      'Si vous avez besoin d&#39;aide pendant que vous êtes en voyage, veuillez nous appeler au 416 734-3904.</p>'
    ].join('\n')
  },
  pageNotFound: {
    docTitle: 'Page non trouvée',
    pageTitle: 'Nous ne trouvons pas la page que vous cherchez.',
    siteMapTitle: 'Voici plutôt le plan du site :'
  },
  // homePage,
  // homePageV2,
  homePageV3,
  productVideoNonMembers,
  productVideoMembers,
  alertsPage,
  identityPage,
  protectionPage,
  activatePage,
  termsAndConditionsPage,
  termsOfUsePage,
  privacyPolicyPage,
  faqPage,
  contactUsPage,
  resourceCentrePage,
  ScamDetectionPage
};
